import { PATH_CORP_FAQ, PATH_PREMIUM_OFFERS_SHOP } from "@capone/common";
import { PATH_PREMIER_COLLECTION_SHOP_DETAILS } from "redmond";

export { PATH_PREMIER_COLLECTION_SHOP_DETAILS } from "redmond";

export const PATH_HOME = "/";
// TODO: remove temporary basic auth once ready (see https://hopper-jira.atlassian.net/browse/BP-98)
export const PATH_BASIC_AUTH = `${PATH_HOME}basicAuth/`;
export const PATH_FLIGHTS = `${PATH_HOME}flights/`;
export const PATH_FLIGHTS_BOOK = `${PATH_FLIGHTS}book/`;
export const PATH_FLIGHTS_SEARCH = `${PATH_FLIGHTS}search/`;
export const PATH_FLIGHTS_SHOP = `${PATH_FLIGHTS}shop/`;
export const PATH_FLIGHTS_SHOP_MULTICITY = `${PATH_FLIGHTS_SHOP}multicity/`;
export const PATH_FLIGHTS_SHOP_RETURN = `${PATH_FLIGHTS_SHOP}return/`;
export const PATH_FLIGHTS_SHOP_REVIEW = `${PATH_FLIGHTS_SHOP}review/`;
export const PATH_FLIGHTS_SHOP_REVIEW_FARE = `${PATH_FLIGHTS_SHOP}review/fare/`;
export const PATH_FLIGHTS_SHOP_CUSTOMIZE = `${PATH_FLIGHTS_SHOP}customize/`;
export const PATH_FLIGHTS_CHANGE = `${PATH_FLIGHTS}change/`;
export const PATH_FLIGHTS_BOOK_CONFIRMATION = `${PATH_FLIGHTS_BOOK}confirm/`;
export const PATH_FLIGHTS_BOOK_WITH_VI_CONFIRMATION = `${PATH_FLIGHTS_BOOK}virtualInterline/confirm/`;
export const PATH_DISRUPTION_OFFER = `${PATH_FLIGHTS}disruption-offer/`;
export const PATH_CFAR_OFFER = `${PATH_FLIGHTS}cfar-offer/`;
export const PATH_CFAR_OFFER_CONFIRMATION = `${PATH_CFAR_OFFER}confirm/`;
export const PATH_FLIGHTS_ANCILLARY = `${PATH_FLIGHTS}ancillary/`;
export const PATH_FLIGHTS_ANCILLARY_DISRUPTION = `${PATH_FLIGHTS_ANCILLARY}disruption/`;
export const PATH_FLIGHTS_ANCILLARY_DISRUPTION_CONFIRM = `${PATH_FLIGHTS_ANCILLARY_DISRUPTION}confirm/`;
export const PATH_HOTELS = `${PATH_HOME}hotels/`;
export const PATH_HOTELS_BOOK = `${PATH_HOTELS}book/`;
export const PATH_HOTELS_SEARCH = `${PATH_HOTELS}search/`;
export const PATH_HOTELS_AVAILABILITY = `${PATH_HOTELS}availability/`;
export const PATH_HOTELS_SHOP = `${PATH_HOTELS}shop/`;
export const PATH_HOTELS_ANCILLARY = `${PATH_HOTELS}ancillary/`;
export const PATH_HOTELS_ANCILLARY_CUSTOMIZE = `${PATH_HOTELS_ANCILLARY}customize/`;
export const PATH_HOTELS_BOOK_CONFIRMATION = `${PATH_HOTELS_BOOK}confirm/`;

// The Stays paths are aliases for Hotels
export const PATH_STAYS = `${PATH_HOME}stays/`;
export const PATH_STAYS_SEARCH = `${PATH_STAYS}search/`;
export const PATH_STAYS_AVAILABILITY = `${PATH_STAYS}availability/`;
export const PATH_STAYS_SHOP = `${PATH_STAYS}shop/`;
export const PATH_STAYS_BOOK = `${PATH_STAYS}book/`;

export const PATH_VACATION_RENTALS = `${PATH_HOME}vacation-rentals/`;

export const PATH_FAVORITES = `${PATH_HOME}favorites/`;

export const PATH_CARS = `${PATH_HOME}cars/`;
export const PATH_CARS_SEARCH = `${PATH_CARS}search/`;
export const PATH_CARS_AVAILABILITY = `${PATH_CARS}availability/`;
export const PATH_CARS_SHOP = `${PATH_CARS}shop/`;
export const PATH_CARS_BOOK = `${PATH_CARS}book/`;
export const PATH_CARS_BOOK_CONFIRMATION = `${PATH_CARS_BOOK}confirm/`;
export const PATH_TRIPS = `${PATH_HOME}trips/`;
export const PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW = `${PATH_TRIPS}disruption/`;
export const PATH_TRIPS_DISRUPTION_PROTECTION_REFUND = `${PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW}refund/`;
const PATH_TRIPS_DISRUPTION_PROTECTION_REBOOK = `${PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW}rebook/`;
const PATH_TRIPS_DISRUPTION_PROTECTION_CONTACT_SUPPORT = `${PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW}contact-support/`;
const PATH_TRIPS_DISRUPTION_PROTECTION_REBOOK_FLIGHT = `${PATH_TRIPS_DISRUPTION_PROTECTION_REBOOK}flight/`;
const PATH_TRIPS_DISRUPTION_PROTECTION_REBOOK_CONNECTION = `${PATH_TRIPS_DISRUPTION_PROTECTION_REBOOK}connection/`;
export const PATH_TRIPS_DISRUPTION_MCP_REBOOK_CONNECTING_FLIGHT = `${PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW}rebook-connecting-flight/`;
export const TRIPS_PATH_HOTELS = `${PATH_TRIPS}hotels/`;
export const PATH_TRIPS_CHANGE_FOR_ANY_REASON = `${PATH_TRIPS}change/`;
export const PATH_TERMS = `${PATH_HOME}terms/`;
export const PRICE_DROP_PROTECTION = `${PATH_TERMS}price-drop-protection/`;
export const MISSED_CONNECTION_GUARANTEE = `${PATH_TERMS}missed-connection-guarantee/`;
export const BEST_PRICE_GUARANTEE = `${PATH_TERMS}best-price-guarantee/`;
export const PRICE_PREDICTION_PRICE_WATCH = `${PATH_TERMS}price-prediction-price-watch/`;
export const PATH_TERMS_CFAR = `${PATH_TERMS}cancel-for-any-reason`;
export const PATH_TERMS_TRAVEL_CREDITS = `${PATH_TERMS}travel-credits/`;
export const PATH_TERMS_OF_SERVICE = `${PATH_HOME}terms-of-service/`;
export const PATH_SITE_TERMS_OF_USE = `${PATH_HOME}site-terms-of-use/`;
export const PATH_AUTH = `${PATH_HOME}auth/`;
export const PATH_AUTH_FTUX = `${PATH_AUTH}ftux/`;
export const PATH_AUTH_START_SESSION = `${PATH_AUTH}startsession/`;
export const PATH_AUTH_INVALID_SESSION = `${PATH_AUTH}invalidsession/`;
export const PATH_PREMIER_COLLECTION = `${PATH_HOME}premium-stays/`;
export const PATH_PREMIER_COLLECTION_SEARCH = `${PATH_PREMIER_COLLECTION}search/`;
export const PATH_PREMIER_COLLECTION_AVAILABILITY = `${PATH_PREMIER_COLLECTION}availability/`;
export const PATH_PREMIER_COLLECTION_ANCILLARY = `${PATH_PREMIER_COLLECTION}ancillary/`;
export const PATH_PREMIER_COLLECTION_ANCILLARY_CUSTOMIZE = `${PATH_PREMIER_COLLECTION_ANCILLARY}customize/`;
export const PATH_PREMIER_COLLECTION_BOOK = `${PATH_PREMIER_COLLECTION}book/`;
export const PATH_PREMIER_COLLECTION_BOOK_CONFIRMATION = `${PATH_PREMIER_COLLECTION_BOOK}confirm/`;
export const PATH_EXCHANGE = `${PATH_HOME}exchange`;
export const PATH_EXCHANGE_FLIGHT = `${PATH_EXCHANGE}/flight`;
export const PATH_EXCHANGE_FLIGHT_SHOP = `${PATH_EXCHANGE_FLIGHT}/shop`;
export const PATH_EXCHANGE_FLIGHT_CONFIRM = `${PATH_EXCHANGE_FLIGHT}/confirm`;
export const PATH_EXCHANGE_FLIGHT_BOOK = `${PATH_EXCHANGE_FLIGHT}/book`;
export const PATH_TRAVEL_WALLET = `${PATH_HOME}travel-offers/`;
export const PATH_TRAVEL_WALLET_V2 = `${PATH_HOME}travel-wallet`;
export const PATH_TRAVEL_SALE = `/travelsale/`;
export const PATH_PREMIER_COLLECTION_SHOP = `${PATH_PREMIER_COLLECTION}shop/`;
export const PATH_VIBES = `${PATH_PREMIER_COLLECTION}vibes/`;
export const PATH_PREMIER_VACATION_RENTALS = `${PATH_PREMIER_COLLECTION}vacation-rentals/`;
export const PATH_PREMIER_VACATION_RENTALS_AVAILABILITY = `${PATH_PREMIER_VACATION_RENTALS}availability/`;
export const PATH_PREMIER_VACATION_RENTALS_SHOP = `${PATH_PREMIER_VACATION_RENTALS}shop/`;
export const PATH_PREMIER_VACATION_RENTALS_SEARCH = `${PATH_PREMIER_VACATION_RENTALS}search/`;
export const PATH_PREMIER_VACATION_RENTALS_BOOK = `${PATH_PREMIER_VACATION_RENTALS}book/`;
export const PATH_PREMIER_VACATION_RENTALS_BOOK_CONFIRMATION = `${PATH_PREMIER_VACATION_RENTALS_BOOK}confirm/`;
export const PATH_CUSTOMER_PROFILE = `${PATH_HOME}profile/`;
export const PATH_PACKAGES = `${PATH_HOME}packages/`;
export const PATH_HOTELS_FLIGHTS = `${PATH_HOME}hotels-flights/`;
export const PATH_PACKAGES_SEARCH = `${PATH_PACKAGES}search/`;
export const PATH_HOTELS_FLIGHTS_SEARCH = `${PATH_HOTELS_FLIGHTS}search/`;
export const PATH_PACKAGES_HOTEL_AVAILABILITY = `${PATH_PACKAGES}hotels-availability/`;
export const PATH_CORE_PACKAGES_HOTEL_AVAILABILITY = `${PATH_PACKAGES}hotels/availability/`;
export const PATH_HOTELS_FLIGHTS_HOTEL_AVAILABILITY = `${PATH_HOTELS_FLIGHTS}hotels-availability/`;
export const PATH_CORE_HOTELS_FLIGHTS_HOTEL_AVAILABILITY = `${PATH_HOTELS_FLIGHTS}hotels/availability/`;
export const PATH_PACKAGES_BOOK = `${PATH_PACKAGES}book/`;
export const PATH_HOTELS_FLIGHTS_BOOK = `${PATH_HOTELS_FLIGHTS}book/`;
export const PATH_PACKAGES_BOOK_CONFIRMATION = `${PATH_PACKAGES_BOOK}confirm/`;
export const PATH_HOTELS_FLIGHTS_BOOK_CONFIRMATION = `${PATH_HOTELS_FLIGHTS_BOOK}confirm/`;
export const PATH_PACKAGE_HOTEL_SHOP = `${PATH_PACKAGES}hotel-shop/`;
export const PATH_CORE_PACKAGES_HOTEL_SHOP = `${PATH_PACKAGES}hotels/shop/`;
export const PATH_CORE_PACKAGES_HOTEL_SHOP_ROOMS = `${PATH_PACKAGES}hotels/shop/rooms/`;
export const PATH_HOTELS_FLIGHTS_HOTEL_SHOP = `${PATH_HOTELS_FLIGHTS}hotel-shop/`;
export const PATH_CORE_HOTELS_FLIGHTS_HOTEL_SHOP = `${PATH_HOTELS_FLIGHTS}hotels/shop/`;
export const PATH_CORE_HOTELS_FLIGHTS_HOTEL_SHOP_ROOMS = `${PATH_HOTELS_FLIGHTS}hotels/shop/rooms/`;
export const PATH_PACKAGE_FLIGHT_SHOP = `${PATH_PACKAGES}flight-shop/`;
export const PATH_CORE_PACKAGES_FLIGHT_SHOP_OUTBOUND = `${PATH_PACKAGES}flights/shop/outbound/`;
export const PATH_CORE_PACKAGES_FLIGHT_SHOP_RETURN = `${PATH_PACKAGES}flights/shop/return/`;
export const PATH_HOTELS_FLIGHTS_FLIGHT_SHOP = `${PATH_HOTELS_FLIGHTS}flight-shop/`;
export const PATH_CORE_HOTELS_FLIGHTS_FLIGHT_SHOP_OUTBOUND = `${PATH_HOTELS_FLIGHTS}flights/shop/outbound/`;
export const PATH_CORE_HOTELS_FLIGHTS_FLIGHT_SHOP_RETURN = `${PATH_HOTELS_FLIGHTS}flights/shop/return/`;
export const PATH_PACKAGE_REVIEW = `${PATH_PACKAGES}review/`;
export const PATH_HOTELS_FLIGHTS_REVIEW = `${PATH_HOTELS_FLIGHTS}review/`;
export const PATH_VACATION_RENTALS_SHOP = `${PATH_VACATION_RENTALS}shop/`;
export const PATH_VACATION_RENTALS_BOOK = `${PATH_VACATION_RENTALS}book/`;
export const PATH_VACATION_RENTALS_BOOK_CONFIRMATION = `${PATH_VACATION_RENTALS_BOOK}confirm/`;

export const PATH_ACTIVITIES = `${PATH_HOME}activities/`;
export const PATH_ACTIVITIES_SEARCH = `${PATH_ACTIVITIES}search/`;
export const PATH_ACTIVITIES_AVAILABILITY = `${PATH_ACTIVITIES}availability/`;
export const PATH_ACTIVITIES_SHOP = `${PATH_ACTIVITIES}shop/`;
export const PATH_ACTIVITIES_BOOK = `${PATH_ACTIVITIES}book/`;
export const PATH_ACTIVITIES_BOOK_CONFIRMATION = `${PATH_ACTIVITIES_BOOK}confirm/`;
export const PATH_WEBVIEW = `${PATH_HOME}webview/`;
export const PATH_WEBVIEW_PRELOAD = `${PATH_WEBVIEW}preload/`;

export const PATH_CRUISES = `${PATH_HOME}cruises/`;
export const PATH_CRUISES_AVAILABILITY = `${PATH_CRUISES}availability/`;
export const PATH_CRUISES_SHOP = `${PATH_CRUISES}shop/`;
export const PATH_CRUISES_BOOK = `${PATH_CRUISES}book/`;
export const PATH_CRUISES_BOOK_CONFIRMATION = `${PATH_CRUISES_BOOK}confirm/`;

// corporate travel
export const PATH_CORP_ACCESS_DENIED = `${PATH_HOME}access-denied/`;
export const PATH_CORP_ACCESS_DENIED_NOT_BETA = `${PATH_HOME}access-denied-not-beta/`;

// corporate travel admin
export const PATH_BUSINESS = `${PATH_HOME}business/`;
export const PATH_BUSINESS_REGEX = /business/;

export const PATH_MY_PROFILE = `${PATH_HOME}profile/`;
export const PATH_MY_PROFILE_REGEX = /profile/;

export const HIDDEN_FOOTER_PATHS = [
  PATH_HOTELS_AVAILABILITY,
  PATH_STAYS_AVAILABILITY,
  PATH_FAVORITES,
  PATH_PREMIER_COLLECTION_AVAILABILITY,
  PATH_PREMIER_VACATION_RENTALS_AVAILABILITY,
  PATH_PACKAGES_HOTEL_AVAILABILITY,
  PATH_HOTELS_FLIGHTS_HOTEL_AVAILABILITY,
  PATH_PACKAGE_FLIGHT_SHOP,
  PATH_HOTELS_FLIGHTS_FLIGHT_SHOP,
  PATH_PACKAGE_REVIEW,
  PATH_HOTELS_FLIGHTS_REVIEW,
  PATH_ACTIVITIES_AVAILABILITY,
  PATH_ACTIVITIES_SHOP,
];

export const HIDDEN_FOOTER_PATHS_MOBILE = [
  PATH_PREMIER_COLLECTION_SEARCH,
  PATH_HOTELS_SHOP,
  PATH_HOTELS_ANCILLARY_CUSTOMIZE,
  PATH_FLIGHTS_SHOP,
  PATH_FLIGHTS_CHANGE,
  PATH_FLIGHTS_SHOP_REVIEW,
  PATH_FLIGHTS_SHOP_REVIEW_FARE,
  PATH_FLIGHTS_SHOP_CUSTOMIZE,
  PATH_CARS_SHOP,
  PATH_PREMIER_COLLECTION_SHOP,
  PATH_PREMIER_COLLECTION_SHOP_DETAILS,
  PATH_PREMIER_COLLECTION_ANCILLARY_CUSTOMIZE,
  PATH_PREMIER_VACATION_RENTALS,
  PATH_PREMIER_VACATION_RENTALS_SEARCH,
  PATH_PREMIER_VACATION_RENTALS_SHOP,
  PATH_PREMIER_VACATION_RENTALS_AVAILABILITY,
  PATH_VACATION_RENTALS_SHOP,
  PATH_PACKAGES_SEARCH,
  PATH_CORE_PACKAGES_HOTEL_AVAILABILITY,
  PATH_CORE_PACKAGES_HOTEL_SHOP,
  PATH_CORE_PACKAGES_HOTEL_SHOP_ROOMS,
  PATH_CORE_PACKAGES_FLIGHT_SHOP_OUTBOUND,
  PATH_CORE_PACKAGES_FLIGHT_SHOP_RETURN,
  PATH_HOTELS_FLIGHTS_SEARCH,
  PATH_ACTIVITIES_SEARCH,
  PATH_WEBVIEW,
];

export const HIDDEN_FOOTER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const NO_FOOTER_PADDING_PATHS: string[] = [
  PATH_PACKAGES_SEARCH,
  PATH_HOTELS_FLIGHTS_SEARCH,
];

export const NO_FOOTER_PADDING_UNPROTECTED_PATHS: string[] = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const HIDDEN_HEADER_PATHS_DESKTOP = [
  new RegExp(`^${PATH_FLIGHTS}shop/.*`),
  PATH_FLIGHTS_CHANGE,
  PATH_FLIGHTS_BOOK,
  PATH_DISRUPTION_OFFER,
  PATH_CFAR_OFFER,
  PATH_CFAR_OFFER_CONFIRMATION,
  PATH_HOTELS_AVAILABILITY,
  PATH_HOTELS_SHOP,
  PATH_HOTELS_ANCILLARY_CUSTOMIZE,
  PATH_HOTELS_BOOK,
  PATH_STAYS_AVAILABILITY,
  PATH_STAYS_SHOP,
  PATH_FAVORITES,
  PATH_PREMIER_VACATION_RENTALS_BOOK,
  PATH_VACATION_RENTALS_BOOK,
  PATH_CARS_AVAILABILITY,
  PATH_CARS_BOOK,
  `${PATH_CARS}shop/`,
  `${PATH_EXCHANGE}/`,
  `${PATH_EXCHANGE_FLIGHT}/`,
  `${PATH_EXCHANGE_FLIGHT_SHOP}/`,
  `${PATH_EXCHANGE_FLIGHT_CONFIRM}/`,
  `${PATH_EXCHANGE_FLIGHT_BOOK}/`,
  PATH_TRIPS_CHANGE_FOR_ANY_REASON,
  PATH_TRIPS_DISRUPTION_PROTECTION_OVERVIEW,
  PATH_TRIPS_DISRUPTION_PROTECTION_CONTACT_SUPPORT,
  PATH_TRIPS_DISRUPTION_MCP_REBOOK_CONNECTING_FLIGHT,
  PATH_TRIPS_DISRUPTION_PROTECTION_REFUND,
  PATH_TRIPS_DISRUPTION_PROTECTION_REBOOK_FLIGHT,
  PATH_TRIPS_DISRUPTION_PROTECTION_REBOOK_CONNECTION,
  PATH_PREMIER_COLLECTION_AVAILABILITY,
  PATH_PREMIER_COLLECTION_SHOP,
  PATH_PREMIER_COLLECTION_SHOP_DETAILS,
  PATH_PREMIER_COLLECTION_ANCILLARY_CUSTOMIZE,
  PATH_PREMIER_COLLECTION_BOOK,
  PATH_PREMIER_VACATION_RENTALS_AVAILABILITY,
  PATH_PREMIER_VACATION_RENTALS_SHOP,
  PATH_VACATION_RENTALS_SHOP,
  PATH_PACKAGES_HOTEL_AVAILABILITY,
  PATH_CORE_PACKAGES_HOTEL_AVAILABILITY,
  PATH_HOTELS_FLIGHTS_HOTEL_AVAILABILITY,
  PATH_CORE_HOTELS_FLIGHTS_HOTEL_AVAILABILITY,
  PATH_PACKAGES_BOOK,
  PATH_HOTELS_FLIGHTS_BOOK,
  PATH_PACKAGE_HOTEL_SHOP,
  PATH_CORE_PACKAGES_HOTEL_SHOP,
  PATH_CORE_PACKAGES_HOTEL_SHOP_ROOMS,
  PATH_HOTELS_FLIGHTS_HOTEL_SHOP,
  PATH_CORE_HOTELS_FLIGHTS_HOTEL_SHOP,
  PATH_CORE_HOTELS_FLIGHTS_HOTEL_SHOP_ROOMS,
  PATH_PACKAGE_FLIGHT_SHOP,
  PATH_CORE_PACKAGES_FLIGHT_SHOP_OUTBOUND,
  PATH_CORE_PACKAGES_FLIGHT_SHOP_RETURN,
  PATH_HOTELS_FLIGHTS_FLIGHT_SHOP,
  PATH_CORE_HOTELS_FLIGHTS_FLIGHT_SHOP_OUTBOUND,
  PATH_CORE_HOTELS_FLIGHTS_FLIGHT_SHOP_RETURN,
  PATH_PACKAGE_REVIEW,
  PATH_HOTELS_FLIGHTS_REVIEW,
  PATH_ACTIVITIES_AVAILABILITY,
  PATH_ACTIVITIES_SHOP,
  PATH_ACTIVITIES_BOOK,
  PATH_CRUISES,
  PATH_WEBVIEW,
  PATH_BUSINESS_REGEX,
  PATH_MY_PROFILE_REGEX,
  /\/stays\/shop\/.+/,
];

export const pathsListContainsPath = (
  pathsList: (string | RegExp)[],
  path: string
): boolean =>
  pathsList.some((p) => (typeof p === "string" ? p === path : p.test(path)));

export const CORE_HOMEPAGE_BOOKING_CONFIRMATION_PATHS = [
  PATH_CARS_BOOK_CONFIRMATION,
  PATH_FLIGHTS_BOOK_CONFIRMATION,
  PATH_FLIGHTS_BOOK_WITH_VI_CONFIRMATION,
  PATH_HOTELS_BOOK_CONFIRMATION,
  PATH_PACKAGES_BOOK_CONFIRMATION,
  PATH_HOTELS_FLIGHTS_BOOK_CONFIRMATION,
  PATH_VACATION_RENTALS_BOOK_CONFIRMATION,
  PATH_PREMIER_COLLECTION_BOOK_CONFIRMATION,
  PATH_PREMIER_VACATION_RENTALS_BOOK_CONFIRMATION,
  PATH_ACTIVITIES_BOOK_CONFIRMATION,
];

export const isCoreHomepageBookingConfirmationPath = (pathname: string) =>
  CORE_HOMEPAGE_BOOKING_CONFIRMATION_PATHS.some((path) =>
    pathname.startsWith(path)
  );

export const HIDDEN_ROOT_BANNER_PATHS = [PATH_TRAVEL_SALE, PATH_WEBVIEW];

export const CAPONE_HEADER_UPDATED_STYLING_SEARCH_PATHS = [
  PATH_FLIGHTS_SEARCH,
  PATH_HOTELS_SEARCH,
  PATH_STAYS_SEARCH,
  PATH_CARS_SEARCH,
  PATH_HOTELS_FLIGHTS_SEARCH,
];

export const CAPONE_HEADER_UPDATED_STYLING_PATHS = [
  PATH_FLIGHTS_SHOP,
  PATH_FLIGHTS_SHOP_RETURN,
  PATH_FLIGHTS_SHOP_REVIEW,
  PATH_FLIGHTS_SHOP_REVIEW_FARE,
  PATH_FLIGHTS_SHOP_CUSTOMIZE,
  PATH_FLIGHTS_SHOP_MULTICITY,
  PATH_FLIGHTS_CHANGE,
  PATH_FLIGHTS_BOOK,
  PATH_HOTELS_AVAILABILITY,
  PATH_HOTELS_SHOP,
  PATH_STAYS_AVAILABILITY,
  PATH_STAYS_SHOP,
  PATH_FAVORITES,
  PATH_HOTELS_ANCILLARY_CUSTOMIZE,
  PATH_CARS_AVAILABILITY,
  `${PATH_CARS}shop/`,
  `${PATH_EXCHANGE}/`,
  `${PATH_EXCHANGE_FLIGHT_SHOP}/`,
  `${PATH_EXCHANGE_FLIGHT_CONFIRM}/`,
  `${PATH_EXCHANGE_FLIGHT_BOOK}/`,
  PATH_PREMIER_COLLECTION_AVAILABILITY,
  PATH_PREMIER_COLLECTION_SHOP,
  PATH_PREMIER_COLLECTION_SHOP_DETAILS,
  PATH_PREMIER_COLLECTION_ANCILLARY_CUSTOMIZE,
  PATH_PREMIER_VACATION_RENTALS_AVAILABILITY,
  PATH_PREMIER_VACATION_RENTALS_SHOP,
  PATH_PACKAGES_HOTEL_AVAILABILITY,
  PATH_HOTELS_FLIGHTS_HOTEL_AVAILABILITY,
  PATH_PACKAGE_HOTEL_SHOP,
  PATH_HOTELS_FLIGHTS_HOTEL_SHOP,
  PATH_PACKAGE_FLIGHT_SHOP,
  PATH_HOTELS_FLIGHTS_FLIGHT_SHOP,
  PATH_PACKAGE_REVIEW,
  PATH_ACTIVITIES_AVAILABILITY,
  PATH_ACTIVITIES_SHOP,
  PATH_VACATION_RENTALS_SHOP,
  PATH_VACATION_RENTALS_BOOK_CONFIRMATION,
];

export const HIDDEN_HEADER_PATHS_MOBILE_GLOBAL_NAV: (string | RegExp)[] = [
  PATH_FLIGHTS_BOOK,
  PATH_FLIGHTS_CHANGE,
  PATH_HOTELS_BOOK,
  PATH_PREMIER_VACATION_RENTALS_BOOK,
  PATH_VACATION_RENTALS_BOOK,
  PATH_PREMIER_COLLECTION_BOOK,
  PATH_CARS_BOOK,
  PATH_PACKAGES_SEARCH,
  PATH_HOTELS_FLIGHTS_SEARCH,
  PATH_ACTIVITIES_SEARCH,
  PATH_PACKAGES_BOOK,
  PATH_HOTELS_FLIGHTS_BOOK,
  PATH_ACTIVITIES_BOOK,
  PATH_WEBVIEW,
  PATH_BUSINESS_REGEX,
  PATH_MY_PROFILE_REGEX,
];

export const HIDDEN_HEADER_PATHS_MOBILE = [
  PATH_FLIGHTS_SHOP,
  PATH_FLIGHTS_CHANGE,
  PATH_FLIGHTS_BOOK,
  PATH_HOTELS_AVAILABILITY,
  PATH_HOTELS_SHOP,
  PATH_HOTELS_ANCILLARY_CUSTOMIZE,
  PATH_HOTELS_BOOK,
  PATH_STAYS_AVAILABILITY,
  PATH_FAVORITES,
  PATH_PREMIER_VACATION_RENTALS_BOOK,
  PATH_VACATION_RENTALS_BOOK,
  PATH_CARS_AVAILABILITY,
  PATH_CARS_BOOK,
  `${PATH_CARS}shop/`,
  `${PATH_EXCHANGE}/`,
  `${PATH_EXCHANGE_FLIGHT}/`,
  `${PATH_EXCHANGE_FLIGHT_SHOP}/`,
  `${PATH_EXCHANGE_FLIGHT_CONFIRM}/`,
  `${PATH_EXCHANGE_FLIGHT_BOOK}/`,
  PATH_PREMIER_COLLECTION_AVAILABILITY,
  PATH_PREMIER_COLLECTION_SHOP,
  PATH_PREMIER_COLLECTION_SHOP_DETAILS,
  PATH_PREMIER_COLLECTION_ANCILLARY_CUSTOMIZE,
  PATH_PREMIER_COLLECTION_BOOK,
  PATH_PREMIER_VACATION_RENTALS_AVAILABILITY,
  PATH_PREMIER_VACATION_RENTALS_SHOP,
  PATH_VACATION_RENTALS_SHOP,
  PATH_PACKAGES_HOTEL_AVAILABILITY,
  PATH_CORE_PACKAGES_HOTEL_AVAILABILITY,
  PATH_HOTELS_FLIGHTS_HOTEL_AVAILABILITY,
  PATH_CORE_HOTELS_FLIGHTS_HOTEL_AVAILABILITY,
  PATH_PACKAGES_BOOK,
  PATH_HOTELS_FLIGHTS_BOOK,
  PATH_PACKAGE_HOTEL_SHOP,
  PATH_CORE_PACKAGES_HOTEL_SHOP,
  PATH_CORE_PACKAGES_HOTEL_SHOP_ROOMS,
  PATH_HOTELS_FLIGHTS_HOTEL_SHOP,
  PATH_CORE_HOTELS_FLIGHTS_HOTEL_SHOP,
  PATH_CORE_HOTELS_FLIGHTS_HOTEL_SHOP_ROOMS,
  PATH_PACKAGE_FLIGHT_SHOP,
  PATH_CORE_PACKAGES_FLIGHT_SHOP_OUTBOUND,
  PATH_CORE_PACKAGES_FLIGHT_SHOP_RETURN,
  PATH_HOTELS_FLIGHTS_FLIGHT_SHOP,
  PATH_CORE_HOTELS_FLIGHTS_FLIGHT_SHOP_OUTBOUND,
  PATH_CORE_HOTELS_FLIGHTS_FLIGHT_SHOP_RETURN,
  PATH_PACKAGE_REVIEW,
  PATH_HOTELS_FLIGHTS_REVIEW,
  PATH_ACTIVITIES_AVAILABILITY,
  PATH_ACTIVITIES_SHOP,
  PATH_ACTIVITIES_BOOK,
  PATH_WEBVIEW,
];

export const DISPLAY_HOMEPAGE_TAKEOVER_PATHS = [
  PATH_FLIGHTS,
  PATH_HOTELS,
  PATH_STAYS,
  PATH_CARS,
  PATH_HOME,
  PATH_FLIGHTS_SEARCH,
  PATH_HOTELS_SEARCH,
  PATH_STAYS_SEARCH,
  PATH_CARS_SEARCH,
  PATH_PREMIER_COLLECTION,
  PATH_PREMIER_COLLECTION_SEARCH,
  PATH_PACKAGES,
  PATH_HOTELS_FLIGHTS,
  PATH_ACTIVITIES,
];

export const UNPROTECTED_PATHS = [
  PATH_AUTH,
  PATH_TERMS,
  PATH_TERMS_OF_SERVICE,
  PATH_SITE_TERMS_OF_USE,
  PRICE_DROP_PROTECTION,
  MISSED_CONNECTION_GUARANTEE,
  BEST_PRICE_GUARANTEE,
  PRICE_PREDICTION_PRICE_WATCH,
  PATH_CORP_ACCESS_DENIED,
  PATH_CORP_ACCESS_DENIED_NOT_BETA,
  PATH_CORP_FAQ,
];

export const HIDDEN_HEADER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
];

export const HIDDEN_BANNER_UNPROTECTED_PATHS = [
  PATH_AUTH_FTUX,
  PATH_AUTH_START_SESSION,
  PATH_AUTH_INVALID_SESSION,
  ...UNPROTECTED_PATHS,
];

export const HIDDEN_BANNER_PROTECTED_PATHS = [];

export const HIDDEN_HEADER_DETAILS_PATHS = [
  PATH_CORP_ACCESS_DENIED,
  PATH_CORP_ACCESS_DENIED_NOT_BETA,
];

export const POSITION_FIXED_FOOTER_PATHS: string[] = [];

export const PATHS_WITH_FIXED_RESERVED_COMPONENT: string[] = [
  PATH_CARS_SHOP,
  PATH_HOTELS_SHOP,
];

export const PRICE_MATCH_BANNER_PATHS = [
  PATH_CARS_BOOK,
  PATH_CARS_BOOK_CONFIRMATION,
  PATH_HOTELS_BOOK,
  PATH_HOTELS_BOOK_CONFIRMATION,
  PATH_FLIGHTS_BOOK,
  PATH_FLIGHTS_BOOK_CONFIRMATION,
  PATH_FLIGHTS_ANCILLARY_DISRUPTION_CONFIRM,
  PATH_PREMIER_VACATION_RENTALS_BOOK,
  PATH_PREMIER_VACATION_RENTALS_BOOK_CONFIRMATION,
];

export const HIDDEN_FUNNEL_ENTRY_HEADER_PATHS = [
  PATH_CARS_BOOK_CONFIRMATION,
  PATH_HOTELS_BOOK_CONFIRMATION,
  PATH_PREMIER_VACATION_RENTALS_BOOK_CONFIRMATION,
  PATH_VACATION_RENTALS_SHOP,
  PATH_VACATION_RENTALS_BOOK,
  PATH_VACATION_RENTALS_BOOK_CONFIRMATION,
  PATH_FLIGHTS_BOOK_CONFIRMATION,
  PATH_FLIGHTS_BOOK_WITH_VI_CONFIRMATION,
  PATH_PREMIER_COLLECTION_BOOK_CONFIRMATION,
  PATH_FLIGHTS_ANCILLARY_DISRUPTION_CONFIRM,
  PATH_TRIPS,
  PATH_TRAVEL_WALLET,
  PATH_TRAVEL_WALLET_V2,
  PATH_TRAVEL_SALE,
  PATH_AUTH,
  PATH_HOTELS_ANCILLARY_CUSTOMIZE,
  PATH_PREMIER_COLLECTION_ANCILLARY_CUSTOMIZE,
  PATH_CUSTOMER_PROFILE,
  PATH_PACKAGES_BOOK_CONFIRMATION,
  PATH_HOTELS_FLIGHTS_BOOK_CONFIRMATION,
  PATH_ACTIVITIES_BOOK_CONFIRMATION,
  PATH_WEBVIEW,
  PATH_PREMIUM_OFFERS_SHOP,
  PATH_VIBES,
];

export const ADDITIONAL_MOBILE_REDESIGN_HEADER_FOOTER_PATHS = [
  PATH_FLIGHTS_SEARCH,
  PATH_HOTELS_SEARCH,
  PATH_STAYS_SEARCH,
  PATH_CARS_SEARCH,
  PATH_PREMIER_COLLECTION_SEARCH,
];

export const PREMIER_COLLECTION_BANNER_STYLE_PATHS = [
  PATH_PREMIER_COLLECTION,
  PATH_PREMIER_COLLECTION_AVAILABILITY,
  PATH_PREMIER_COLLECTION_SHOP,
  PATH_PREMIER_COLLECTION_SHOP_DETAILS,
  PATH_PREMIER_COLLECTION_ANCILLARY_CUSTOMIZE,
  PATH_PREMIER_COLLECTION_BOOK,
  PATH_PREMIER_COLLECTION_BOOK_CONFIRMATION,
  PATH_VIBES,
  PATH_PREMIER_VACATION_RENTALS,
  PATH_PREMIER_VACATION_RENTALS_AVAILABILITY,
  PATH_PREMIER_VACATION_RENTALS_SHOP,
  PATH_PREMIER_VACATION_RENTALS_BOOK,
  PATH_PREMIER_VACATION_RENTALS_BOOK_CONFIRMATION,
];

export const HOME_PAGE_PATHS = [
  PATH_FLIGHTS,
  PATH_HOTELS,
  PATH_STAYS,
  PATH_CARS,
  PATH_HOME,
  PATH_PACKAGES,
  PATH_ACTIVITIES,
  PATH_CRUISES,
];

export const DISPLAY_CROSS_SELL_AND_RV_PATHS = [...HOME_PAGE_PATHS];
